import axios from 'axios';
import React, { useEffect, useState } from 'react'
interface UserDetails {
 
  firstname: string;
   lastname: string;
  username: string;
  email: string;
  phone: string;
  password: string;
  	wallet:string;
    profileImage:string;
 
    created_at:string;
    action:string;
}

function Agent() {
    const api = process.env.REACT_APP_API_URL as string;
        const[userdetails, setUserdetails] = useState<UserDetails[]>([]);

         const [error, setError] = useState<string>("");

         useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${api}/auth/agents/`);
        setUserdetails(response.data);
        console.log("Fetched user data:", response.data);
      } catch (error: any) {
        setError("Unable to fetch user details.");
        console.error("Fetch failed:", error);
      }
    };

    fetchUserData();
  }, [api]);

    return (
        <>
        <div className="w-full h-auto p-4 sm:p-6 md:p-8">
  <div className="w-full bg-white rounded-xl">
    <div className="w-full">
      <h1 className="text-[20px] font-bold text-gray-800 py-4 px-6">Agents</h1>
    </div>
    <div className="w-full border-b border-[#c0bebe] border-dashed" />

    <div className="flex flex-wrap gap-4 px-6 py-4 items-center">
      <div className="flex items-center gap-2">
        <label className="text-[16px] font-medium text-[#555454]">Show</label>
        <select className="border border-[#c0bfbf] rounded-md w-[70px] h-[32px] px-2">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
        <span className="text-[16px] font-medium text-[#555454] pl-2">entries</span>
      </div>

      <div className="flex items-center gap-2 flex-wrap sm:flex-nowrap sm:ml-auto">
        <label className="text-[16px] font-medium text-[#555454]">Search:</label>
        <input
          type="text"
          className="border border-[#c0bfbf] rounded-md h-[32px] px-3 w-full sm:w-[250px]"
          placeholder="Search..."
        />
      </div>
    </div>

    <div className="px-6 py-4">
      <div className="overflow-x-auto">
       <table className="min-w-full border-collapse border border-gray-300 text-sm">
  <thead>
    <tr className="bg-gray-200 text-gray-700">
      <th className="border border-gray-300 px-4 py-2">S.N</th>
      <th className="border border-gray-300 px-4 py-2">User Name</th>
      <th className="border border-gray-300 px-4 py-2">First Name</th>
      <th className="border border-gray-300 px-4 py-2">Last Name</th>
      <th className="border border-gray-300 px-4 py-2">Phone</th>
      <th className="border border-gray-300 px-4 py-2">Wallet</th>
      <th className="border border-gray-300 px-4 py-2">Date</th>
      <th className="border border-gray-300 px-4 py-2">Action</th>
    </tr>
  </thead>
  <tbody>
    {userdetails.length > 0 ? (
      userdetails.map((item, index) => (
        <tr key={index} className="text-gray-700 hover:bg-gray-50">
          <td className="border border-gray-300 px-4 py-2 text-center">{index + 1}</td>
          <td className="border border-gray-300 px-4 py-2">{item.username}</td>
          <td className="border border-gray-300 px-4 py-2">{item.firstname}</td>
          <td className="border border-gray-300 px-4 py-2">{item.lastname}</td>
          <td className="border border-gray-300 px-4 py-2">{item.phone}</td>
          <td className="border border-gray-300 px-4 py-2">{item.wallet}</td>
          <td className="border border-gray-300 px-4 py-2">
            {new Date(item.created_at).toLocaleDateString()}
          </td>
          <td className="border border-gray-300 px-4 py-2 text-center">
            <button className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600">
              Edit
            </button>
            <button className="bg-red-500 text-white px-3 py-1 rounded ml-2 hover:bg-red-600">
              Delete
            </button>
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td
          colSpan={8}
          className="text-center text-[16px] font-medium text-[#555454] py-4 border border-dashed border-[#c0bebe]"
        >
          No data available in table
        </td>
      </tr>
    )}
  </tbody>
</table>

      </div>

      <div className="w-full flex flex-col sm:flex-row justify-between items-center gap-4 py-4">
        <span className="text-[16px] font-medium text-[#555454] text-center sm:text-left">
          Showing 0 to 0 of 0 entries
        </span>
        <div>
          <button
            className="px-4 py-1 border border-[#c0bebe] text-gray-400 bg-gray-100 cursor-not-allowed rounded-l-md"
            disabled
          >
            Previous
          </button>
          <button
            className="px-4 py-1 border border-[#c0bebe] text-gray-400 bg-gray-100 cursor-not-allowed rounded-r-md"
            disabled
          >
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

        </>
    )
}

export default Agent
